import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MultiSelectorDetails } from 'src/app/model/multi-selector-details';
import { messages } from 'src/app/resources/messages';
import { CatalogService } from 'src/app/services/catalog.service';

@Component({
  selector: 'employee-dropdown',
  templateUrl: './employee-dropdown.component.html',
  styleUrls: ['./employee-dropdown.component.scss']
})
export class EmployeeDropdownComponent implements OnInit {

  @Input() isOptional: boolean = true;
  @Input() displayLabel!: string;
  @Input() allowMultiSelect: boolean = true;
  @Input() selectorControlName!: AbstractControl<string>;
  @Input() submitted!: string;
  @Input() ariaText: string =
    'Employee Expandable List. Click or press enter to expand. Use arrow keys or tab to navigate through the list items and Esc key to close expanded list.';
  @Output() selectedValues = new EventEmitter<string[]>();
  
  @ViewChild('idEmployeeReference') idEmployeeRef: ElementRef | undefined;

  public msg = messages;
  public employeeList: MultiSelectorDetails[] = [];
  public maxSelectionCount: number | undefined;
  public componentId!: string;
  constructor(private catalogService: CatalogService) { }

  ngOnInit(): void {
    this.setId();
    this.getEmployee();
    this.setMaxlimit();
  }

  private getEmployee() {
    this.catalogService.getEmployee().subscribe((data) => {
      this.employeeList = data.data.map(
        (x: any) => <MultiSelectorDetails>(<unknown>{
            id: x.xbcUserId,
            description: [x.userName],
          })
      );
    });
  }

  private setId() {
    if (!this.displayLabel) {
      this.componentId = 'emp';
    } else {
      this.componentId = this.displayLabel.replace(' ', '-');
    }
  }

  public setSelectedEmployee($event: any) {
    let employee: string[] = $event.detail?.selectedItemArray.map(
      (x: MultiSelectorDetails) => x.id
    );
    this.selectedValues.emit(employee);
    if (this.maxSelectionCount === 1) {
      this.idEmployeeRef?.nativeElement.closeSelectionPanel();
    }
  }

  private setMaxlimit() {
    if (this.allowMultiSelect) {
      this.maxSelectionCount = undefined;
    } else {
      this.maxSelectionCount = 1;
    }
  }

  public reset() {
    this.idEmployeeRef?.nativeElement.resetSelectMenu();
  }

  public getAllEmployee(): string[] {
    let allEmployee = this.employeeList.map(
      (x: MultiSelectorDetails) => x.id!);
    return allEmployee;
  }

}
